import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {PredefinedSkillType} from "../../../../skills/types/predefined-skill.type";

require('./skill-tags.scss');
@Component({
  standalone: false,
  selector: 'app-skill-tags',
  templateUrl: './skill-tags.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkillTagsComponent implements OnInit, OnChanges {
  @Input() skillsIds: any;
  @Input() hideDescription: boolean;
  @Input() limit?: number;

  public tags: any[] = [];
  public viewTags: any[] = [];
  public extraTags: any[] = [];
  public visible:boolean;
  public predefinedSkillTypesMap: typeof PredefinedSkillType = PredefinedSkillType;
  public siteSkills: any[];

  constructor(@Inject('splitService') private splitService) {
  }
  ngOnInit() {
    this.siteSkills = this.splitService.getSiteResourceSkills();

    if (!this.limit) {
      this.limit = 2;
    }

    this.setTags();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.skillsIds && !changes.skillsIds.isFirstChange()) {
      this.setTags();
    }
  }

  private setTags() {
    this.tags = [];
    this.viewTags = [];
    this.extraTags = undefined;

    this.tags = (this.skillsIds || []).map((sId) => {
      return this.siteSkills[sId];
    }).filter((tag) => !!tag)

    if (!this.tags?.length) {
      return;
    }

    this.viewTags = this.limit ? this.tags.filter((item, index) => {
      return index < this.limit
    }) : this.tags;

    this.extraTags = this.tags.slice(this.limit);
  }
}
